import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { isValidRedirectUrl } from '../../utils/normalizer';
import Separator from '../../components/separator/Separator';
import LoaderBar from '../../components/loader-bar/LoaderBar';
import SmallWidthContainer from '../../components/small-width-container/SmallWidthContainer';
import LoginEmail from '../login-email/LoginEmail';
import styles from './login.module.less';
import LoginFacebook from '../login-facebook/LoginFacebook';
import { trackPageView } from '../../support-and-tracking/analytics-actions';
import Main from '../../frame/main/Main';
import { loginMessages } from '../user-model';
import ButtonText from '../../components/button/button-text/ButtonText';
import { ContentTitle } from '../../components/typography/Heading';
import GoogleButton from '../../components/button/google-button/GoogleButton';
import { useFeature } from '../../components/hooks/isFeatureEnabled';
import { VIPPS_LOGIN } from '../../constants/features/constants';
import VippsLoginButton from '../../components/button/vipps-login-button/VippsLoginButton';
import withRouter from '../../components/hooks/withRouter';
import { useTitle } from 'hoofd';

const Login = ({ user, existingEmail, redirect, loginMessageText, encryptedEmail, navigate }) => {
    const useVippsLogin = useFeature(VIPPS_LOGIN);
    useEffect(() => {
        trackPageView({ urlAsEvent: 'login' });
        if (user.id) {
            if (isValidRedirectUrl(redirect)) {
                navigate(redirect, { replace: true });
            } else {
                navigate('/me');
            }
        }
    }, []);

    const goToRegisterWithEmail = () => {
        const emailUrlPart = encryptedEmail ? `emailData=${encodeURIComponent(encryptedEmail)}` : '';
        navigate(
            redirect
                ? `/register?redirect=${encodeURIComponent(redirect)}&${emailUrlPart}`
                : `/register?${emailUrlPart}`
        );
    };

    useTitle(user.isFetching ? 'Logger inn' : 'Logg inn');

    if (user.isFetching) {
        return (
            <Main>
                <SmallWidthContainer>
                    <LoaderBar subText="Logger inn …" />
                </SmallWidthContainer>
            </Main>
        );
    }

    const loginMessageElement = loginMessageText ? <p className={styles.errorMessage}>{loginMessageText}</p> : null;

    return (
        <Main>
            <SmallWidthContainer>
                <ContentTitle tag="h1">Logg inn</ContentTitle>
                {loginMessageElement}
                <div className={styles.buttonContainer}>
                    {useVippsLogin && (
                        <VippsLoginButton className={styles.vippsButton} redirectLink={redirect} origin="login-form" />
                    )}
                    <LoginFacebook redirectLink={redirect} origin="login-form" className={styles.facebookButton} />
                    <GoogleButton className={styles.googleButton} redirectLink={redirect} origin="login-form" />
                    <p className={styles.termsText}>
                        Ved å fortsette aksepterer du våre <Link to={'/vilkar'}>vilkår for bruk</Link> og{' '}
                        <Link to={'/personvern'}>personvernerklæring</Link>
                    </p>
                </div>
                <Separator />
                <LoginEmail redirect={redirect} encryptedEmail={encryptedEmail} existingEmail={existingEmail} />
                <ButtonText onClick={goToRegisterWithEmail} category="login-form" action="new-user">
                    Registrer deg
                </ButtonText>
            </SmallWidthContainer>
        </Main>
    );
};

const mapToProps = (state, props) => {
    const query = queryString.parse(props.location.search);
    const encryptedEmail = query.emailData;
    const existingEmail = query.email;
    const redirect = query?.redirect;
    const loginMessage = query?.loginMessage;

    return {
        user: state.user,
        redirect,
        loginMessageText: loginMessage ? loginMessages[loginMessage] : null,
        encryptedEmail,
        existingEmail,
    };
};

export default withRouter(connect(mapToProps)(Login));
